import {Component, inject} from '@angular/core';
import {ColComponent, ContainerComponent, RowComponent} from "@coreui/angular";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatOption, MatSelect, MatSelectChange} from "@angular/material/select";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ISetLogLevel} from "../../interfaces/ISetLogLevel";
import {ActiveUserService} from "../../services/active-user.service";
import {LogLevelService} from "../../services/log-level.service";
import {SnackbarService} from "../../services/snackbar.service";
import {NgIf} from "@angular/common";
import {AppConfigService} from "../../services/app-config.service";

@Component({
  selector: 'app-log-level-switch',
  standalone: true,
  imports: [
    ContainerComponent,
    RowComponent,
    ColComponent,
    MatFormField,
    MatSelect,
    ReactiveFormsModule,
    MatOption,
    MatButton,
    MatProgressSpinner,
    NgIf,
    MatError,
    MatLabel,
    MatHint
  ],
  templateUrl: './log-level-switch.component.html',
  styleUrl: './log-level-switch.component.css'
})
export class LogLevelSwitchComponent {

  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;
  public logLevels = ["Verbose", "Debug", "Information", "Warning", "Error", "Fatal"];
  public targets = ["Api", "Admin App", "Web App"]
  public selectedUrl = "";

  public logLevelControl = new FormControl<string | null>(null, Validators.required);
  public targetControl = new FormControl<string | null>(null, Validators.required);

  public logLevelForm = new FormGroup({
    logLevel: this.logLevelControl,
    target: this.targetControl
  });

  private activeUserService = inject(ActiveUserService);
  private logLevelService = inject(LogLevelService);
  private snackBarService = inject(SnackbarService);
  private appConfigService = inject(AppConfigService);

  submit() {
    if (this.logLevelForm.invalid) {
      this.logLevelForm.markAllAsTouched();
      return;
    }

    this.uiState = UIStateEnum.ShowLoading;

    let command: ISetLogLevel = {
      AdminId: this.activeUserService.activeUser().Id,
      LogLevel: this.logLevelControl.value!
    };

    this.logLevelService.setLogLevel(command, this.targetControl.value!).subscribe({
      next: () => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openSuccessfulSnackBar(`Successfully changed log level to ${this.logLevelControl.value!}`);
      },
      error: err => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openErrorSnackBar("Failed to change log level");
      }
    });
  }

  onSelect($event: MatSelectChange) {
    switch ($event.value) {
      case "Api": {
        this.selectedUrl = `${this.appConfigService.commonApiUrl()}/log/switch-level`;
        break;
      }
      case "Web App": {
        this.selectedUrl = `${this.logLevelService.getWebAppUrl()}api/log/switch-level`;
        break;
      }
      case "Admin App": {
        this.selectedUrl = this.generateAdminUrl();
      }
    }
  }

  generateAdminUrl(): string {
    let environment = this.appConfigService.getEnvironment().toLowerCase();
    if (environment == "local") {
      return "http://localhost:5293/api/log/switch-level";
    } else if (environment == "production") {
      return "https://admin.causable.io/api/log/switch-level"
    }
    else return `https://${environment}-admin.causable.io/api/log/switch-level`;
  }
}
